__turbopack_context__.v({
  "header": "ResultsOutput-module-scss-module__Jues-a__header",
  "headerControls": "ResultsOutput-module-scss-module__Jues-a__headerControls",
  "inner": "ResultsOutput-module-scss-module__Jues-a__inner",
  "linksWrapper": "ResultsOutput-module-scss-module__Jues-a__linksWrapper",
  "normalizeYAxis": "ResultsOutput-module-scss-module__Jues-a__normalizeYAxis",
  "orgLink": "ResultsOutput-module-scss-module__Jues-a__orgLink",
  "organization": "ResultsOutput-module-scss-module__Jues-a__organization",
  "organizations": "ResultsOutput-module-scss-module__Jues-a__organizations",
  "outputName": "ResultsOutput-module-scss-module__Jues-a__outputName",
  "outputNumber": "ResultsOutput-module-scss-module__Jues-a__outputNumber",
  "outputsWrapper": "ResultsOutput-module-scss-module__Jues-a__outputsWrapper",
  "overview": "ResultsOutput-module-scss-module__Jues-a__overview",
  "sparkline": "ResultsOutput-module-scss-module__Jues-a__sparkline",
  "toggleWrapper": "ResultsOutput-module-scss-module__Jues-a__toggleWrapper",
  "wrapper": "ResultsOutput-module-scss-module__Jues-a__wrapper",
});
